<template>
  <div class="pb-2">
    <div v-if="loading" class="px-2">
      <h3>Loading...........</h3>
    </div>
    <div v-if="!loading">
      <b-row class="px-2 d-flex align-items-center">
        <b-col md="3">
          <h3>Agreement</h3>
        </b-col>
        <b-col md="9">
          <b-button
            @click="agreementButtonClick()"
            class="main-navigation-button edit_button"
            variant="white"
            btn-color="primary1"
          >
            <v-avatar size="25"> <img src="img/Edit.png" /> </v-avatar>
          </b-button>
        </b-col>
        <b-modal
          title="Agreement"
          header-class="header-nipige-class"
          id="agreementEdit"
          size="md"
          ref="agreementEdit"
          centered
          hide-footer
        >
          <sagreementmodel
            :catalogData="catalogNames"
            :marketListStore="marketListStore"
            :catalogCategoryNames="catalogCategoryNames"
            :catalogCategoryOptionsProp="catalogCategoryOptions"
          >
            <template v-slot:footer-button="data">
              <b-row class="mt-3">
                <b-col md="4"> </b-col>
                <b-col md="4">
                  <b-button
                    class="btn btn-primary-outline"
                    btn-special="primary"
                    @click="AgreeToNext(data.data)"
                    >Update</b-button
                  >
                </b-col>
                <b-col md="4"></b-col>
              </b-row>
            </template>
          </sagreementmodel>
        </b-modal>
      </b-row>
      <b-row class="px-2 mt-1">
        <b-col>
          <b-row>
            <b-col md="6">
              <p class="left-text">Category Type :</p>
            </b-col>
            <b-col md="6">
              <p class="right-text">{{ categoryTypeData }}</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row>
            <b-col class="line" md="6">
              <p class="left-text">Catalog :</p>
            </b-col>
            <b-col md="6">
              <p
                class="right-text"
                v-for="items in catalogNames"
                :key="items._id"
              >
                {{ items.name }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import sagreementmodel from "@/components/Partner/PartnerEdit/Agreement";
import { mapGetters } from "vuex";
import currentUserMix from "@/mixins/currentUser";
export default {
  props: ["agreeData"],
  mixins: [currentUserMix],
  components: {
    sagreementmodel,
  },
  data() {
    return {
      catalogNames: [],
      catalogCategoryNames: [],
      catalogCategoryOptions: [],
      sameObjCount: [],
      loading: false,
      marketListStore: [],
    };
  },
  methods: {
    async agreementButtonClick() {
      let dataDomain = this.$currentUserData.catalogInfo;
      if (
        Array.isArray(dataDomain) &&
        dataDomain.length > 0 &&
        dataDomain[0].categoryType != "CATEGORY"
      ) {
        try {
          if (
            Array.isArray(this.catalogNames) &&
            this.catalogNames.length > 0
          ) {
            this.catalogNames.forEach(async (obj) => {
              if (obj.isCategory) {
                if (!this.sameObjCount.includes(obj.parent)) {
                  this.sameObjCount.push(obj.parent);
                  await this.$store
                    .dispatch("catalog/fetchCatalogById", obj.parent)
                    .then((res) => {
                      this.catalogCategoryNames.push(
                        this.$store.getters["catalog/GetCurrentReadCatalog"]
                          .response
                      );
                    });
                  let searchString = `parent=${obj.parent}`;
                  await this.$store.dispatch(
                    "catalog/fetchCatalogList",
                    searchString
                  );
                  this.catalogCategoryOptions.push(
                    ...this.$store.getters["catalog/GetCategoryList"].data
                      .response
                  );
                }
              } else {
              }
            });
          }
        } catch {}
        try {
          if (
            this.$store.getters["partner/GetPartnerData"].agreement
              .marketSegment[0].categoryType == "MARKET"
          ) {
            if (
              Array.isArray(this.catalogNames) &&
              this.catalogNames.length > 0
            ) {
              this.catalogNames.forEach(async (obj) => {
                if (obj.isMarket) {
                  let searchStringMarket = `parent=${obj._id}`;
                  await this.$store.dispatch(
                    "catalog/fetchCatalogList",
                    searchStringMarket
                  );
                  this.catalogCategoryOptions.push(
                    ...this.$store.getters["catalog/GetCategoryList"].data
                      .response
                  );
                }
              });
            }
          }
        } catch {}
      }
      this.$refs["agreementEdit"].show();
    },
    async callCatalogTree() {
      try {
        let dataDomain = this.$currentUserData.catalogInfo;
        if (
          Array.isArray(dataDomain) &&
          dataDomain.length > 0 &&
          dataDomain[0].categoryType == "DOMAIN"
        ) {
          let searchString = `parent=${dataDomain[0].catalogId}`;
          await this.$store.dispatch("catalog/fetchCatalogList", searchString);
          let domainRes = this.$store.getters["catalog/GetCategoryList"];
          this.marketListStore = domainRes.data.response;
        }
        if (
          Array.isArray(dataDomain) &&
          dataDomain.length > 0 &&
          dataDomain[0].categoryType == "MARKET"
        ) {
          dataDomain.forEach(async (obj) => {
            await this.$store
              .dispatch("catalog/fetchCatalogById", obj.catalogId)
              .then((res) => {
                this.marketListStore.push(res.response);
              });
          });
        }
        if (
          Array.isArray(dataDomain) &&
          dataDomain.length > 0 &&
          dataDomain[0].categoryType == "CATEGORY"
        ) {
          dataDomain.forEach(async (obj) => {
            await this.$store
              .dispatch("catalog/fetchCatalogById", obj.catalogId)
              .then((res) => {
                this.catalogCategoryOptions.push(res.response);
              });
          });
        } else {
        }
      } catch {}
    },
    AgreeToNext(data) {
      let agreementData = [];
      try {
        if (
          Array.isArray(data.catalogCategory) &&
          data.catalogCategory.length > 0
        ) {
          if (data.fetchCatagoryKey) {
            data.catalogCategory.map((obj) => {
              agreementData.push({
                categoryType: "CATEGORY",
                catalogId: obj._id,
              });
            });
          } else {
            data.catalog.map((obj) => {
              agreementData.push({
                categoryType: data.market.value,
                catalogId: obj._id,
              });
            });
          }
        } else {
          data.catalog.map((obj) => {
            agreementData.push({
              categoryType: data.market.value,
              catalogId: obj._id,
            });
          });
        }
      } catch {
        this.$swal({
          title: "Error",
          text: "Please select market and catalog properly",
          type: "error",
        });
      }
      let agreementPayload = {
        doc: data.doc,
        valid: data.valid,
        marketSegment: agreementData,
      };
      let payload = {
        id: this.partnerAllData._id,
        data: {
          agreement: agreementPayload,
        },
      };
      this.$store
        .dispatch("partner/updatePartner", payload)
        .then((result) => {
          this.$swal({
            title: "Success",
            text: "Partner Edited successfully!",
            type: "success",
          });
          this.$emit("reload-partner", this.partnerAllData._id);
          this.$root.$emit("bv::hide::modal", "agreementEdit", "#btnShow");
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: "Could not Edited partner",
            type: "error",
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      partnerAllData: "partner/GetPartnerData",
      catalogTree: "catalog/GetCatalogTree",
    }),
    categoryTypeData() {
      if (
        Array.isArray(this.agreeData?.marketSegment) &&
        this.agreeData?.marketSegment?.length > 0
      ) {
        return this.agreeData?.marketSegment[0]?.categoryType;
      } else {
        return null;
      }
    },
  },
  async mounted() {
    this.loading = true;
    try {
      if (this.agreeData && this.agreeData.marketSegment) {
        if (
          Array.isArray(this.agreeData.marketSegment) &&
          this.agreeData.marketSegment.length > 0
        ) {
          let storingCatalog = [];
          this.agreeData.marketSegment.forEach(async (el) => {
            await this.$store
              .dispatch("catalog/fetchCatalogById", el.catalogId)
              .then((res) => {
                storingCatalog.push(
                  this.$store.getters["catalog/GetCurrentReadCatalog"].response
                );
              });
          });
          this.catalogNames = storingCatalog;
        }
      }
      await this.callCatalogTree();
    } catch {}
    this.loading = false;
  },
};
</script>
<style scoped>
.text-style {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: rgba(143, 143, 143, 0.87);
}
.left-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  color: #58585b;
}
.right-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}
.list-style {
  list-style-type: none;
  display: inline;
}
[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}
[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 39px;
  width: 90px;
  background-color: var(--primary);
  color: white;
}
[btn-color="primary1"] {
  outline: none !important;
  border-radius: 50%;
  height: 39px;
  width: 39px;
  margin-left: 10px;
  padding: 0;
}
[btn-special="primary1"] {
  border-radius: 50%;
}
@media (max-width: 767px) {
  .my-content {
    display: none;
  }
}
@media (min-width: 767px) {
  .mobile-responsive {
    display: none;
  }
}
@media (max-width: 767px) {
  .edit_button {
    margin-top: -34px;
  }
}
.line {
  border-left: 1px dashed #c2c2c2;
}
</style>
